// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1tmom","title":"BackImages_title__3ZCr3","images":"BackImages_images__3Vx9f"};